import React from "react";
import { useTranslation } from "react-i18next";

export default function useCurrentLanguage(): string {
    const { i18n } = useTranslation();

    return React.useMemo(() => i18n.language, [i18n.language]);
}
